{
  "name": "2021-macyouth-app",
  "description": "MacDonnell Council App",
  "version": "4.2.4",
  "scripts": {
    "preinstall": "node scripts/preinstall-check.mjs",
    "ng": "ng",
    "start": "ng serve",
    "start-docker": "ng serve --host 0.0.0.0",
    "build-production": "CI=1 ng build --base-href / --configuration=production  --output-path=dist/production",
    "build-staging": "CI=1 ng build --base-href / --configuration=staging  --output-path=dist/staging",
    "build-sw": "ng build --base-href / --configuration=sw --output-path=dist/sw",
    "test": "ng test",
    "lint": "ng lint",
    "upload-production-sourcemaps": "bugsnag-source-maps upload-browser --quiet --overwrite --api-key b64f6ba85e9c9662c02eb1d533e13a4a --app-version $npm_package_version --base-url \"*\"  --directory dist/production/browser",
    "upload-staging-sourcemaps": "bugsnag-source-maps upload-browser --quiet --overwrite --api-key b64f6ba85e9c9662c02eb1d533e13a4a --app-version ${npm_package_version}-staging --base-url \"*\" --directory dist/staging/browser",
    "version": "PACKAGE_VERSION=$npm_package_version && echo $PACKAGE_VERSION > VERSION && git add VERSION",
    "postversion": "git push && git push --tags",
    "deploy": "./scripts/deploy.sh",
    "remove": "./scripts/ensure-sst-binary.sh && node -r ./scripts/load-aws-profile.js ./node_modules/.bin/sst remove",
    "unlock": "node scripts/assume-role.js && ./scripts/ensure-sst-binary.sh && node -r ./scripts/load-aws-profile.js ./node_modules/.bin/sst unlock",
    "invalidate-cache": "./scripts/invalidate-cache.sh"
  },
  "private": true,
  "dependencies": {
    "@almothafar/angular-signature-pad": "^4.0.1",
    "@angular/animations": "^22.1.0",
    "@angular/cdk": "^22.1.0",
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/platform-browser": "^22.1.0",
    "@angular/platform-browser-dynamic": "^22.1.0",
    "@angular/router": "^22.1.0",
    "@angular/service-worker": "^22.1.0",
    "@auth0/angular-jwt": "^5.2.0",
    "@bugsnag/js": "^8.0.0",
    "@bugsnag/plugin-angular": "^8.0.0",
    "@fortawesome/fontawesome-pro": "^6.7.2",
    "@hutsix/ngxh6": "^5.1.0",
    "@iharbeck/ngx-virtual-scroller": "^18.0.0",
    "@iplab/ngx-color-picker": "^3.0.1",
    "@ng-bootstrap/ng-bootstrap": "~21.0.0",
    "@ng-select/ng-select": "^23.5.1",
    "@openapitools/openapi-generator-cli": "^2.7.0",
    "angular-calendar": "^0.29.0",
    "chart.js": "^3.0.0",
    "chartjs-plugin-datalabels": "^2.0.0",
    "date-fns": "^2.28.0",
    "leaflet": "^1.9.4",
    "moment": "^2.29.4",
    "moment-timezone": "^0.5.35",
    "ng-bootstrap-darkmode": "^0.5.0",
    "ng2-charts": "^3.0.0",
    "ngx-dropzone-wrapper": "^13.0.0",
    "ngx-indexed-db": "^11.0.2",
    "ngx-moment": "^6.0.2",
    "ngx-pipes": "^3.2.2",
    "ngx-quill": "^31.0.1",
    "parchment": "^3.0.0",
    "rxjs": "~7.8.0",
    "ts-debounce": "^4.0.0",
    "ts-md5": "^1.2.8",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "overrides": {
    "@almothafar/angular-signature-pad": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core"
    },
    "ng-bootstrap-darkmode": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core",
      "@angular/forms": "$@angular/forms",
      "bootstrap-darkmode": "*"
    },
    "bootstrap-darkmode": {
      "bootstrap": "^5.0.0"
    },
    "@iplab/ngx-color-picker": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core",
      "@angular/animations": "$@angular/animations"
    }
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.2",
    "@angular-eslint/builder": "^22.1.0",
    "@angular-eslint/schematics": "^22.1.0",
    "@angular/cli": "^22.1.2",
    "@angular/compiler-cli": "^22.1.0",
    "@angular/localize": "^22.1.0",
    "@aws-sdk/client-sts": "^3.1022.0",
    "@bugsnag/source-maps": "^2.0.0",
    "@compodoc/compodoc": "^1.1.11",
    "@types/jasmine": "~3.10.3",
    "@types/moment-timezone": "^0.5.30",
    "@types/node": "^24",
    "angular-eslint": "^22.1.0",
    "eslint": "^9.28.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~4.0.1",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.3.1",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "nodemon": "^1.3.3",
    "opn": "^6.0.0",
    "prettier": "^3.0.0",
    "sst": "^4.6.9",
    "ts-node": "~10.7.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.66.0",
    "yalc": "^1.0.0-pre.53"
  }
}
